import "./animatedCover.sass";

// AnimatedCover
export function AnimatedCover(props: { children: React.ReactNode }) {
    return <div className="animated-cover">{props.children}</div>;
}
